<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.66699 3.33335C8.66699 2.96516 8.36852 2.66669 8.00033 2.66669C7.63214 2.66669 7.33366 2.96516 7.33366 3.33335V7.33335H3.33366C2.96547 7.33335 2.66699 7.63183 2.66699 8.00002C2.66699 8.36821 2.96547 8.66669 3.33366 8.66669H7.33366V12.6667C7.33366 13.0349 7.63214 13.3334 8.00033 13.3334C8.36852 13.3334 8.66699 13.0349 8.66699 12.6667V8.66669H12.667C13.0352 8.66669 13.3337 8.36821 13.3337 8.00002C13.3337 7.63183 13.0352 7.33335 12.667 7.33335H8.66699V3.33335Z"
      fill="#526C82"
      fill-opacity="0.8"
    />
  </svg>
</template>
